import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { UserSchema, type User } from '~/api/users/types';
// import { createLogger } from '~/lib/logging/createLogger';

// const logger = createLogger('UserContext');

interface UserContextValue {
  user: User | undefined | null;
  storeUser: (user: User | null) => void;
}

const UserContext = createContext<UserContextValue | null>(null);

export function UserProvider({ children }: { children: React.ReactNode }) {
  // state
  const [user, setUser] = useState<User | undefined | null>(undefined);
  const storeUser = useCallback((user: User | null) => {
    localStorage.setItem('user', JSON.stringify(user));
    setUser(user);
  }, []);
  const value = useMemo(() => ({ user, storeUser }), [user, storeUser]);
  // side effects
  // initial fetch from local storage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(UserSchema.parse(JSON.parse(storedUser)));
      } catch {
        // logger.error({ error }, 'Failed to parse user data:');
        setUser(null);
      }
    } else setUser(null);
  }, []);
  // result
  return <UserContext value={value}>{children}</UserContext>;
}

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
